
import {
    GET_POLICIE,
    GET_POLICIE_SUCCESS,
    
    GET_POLICIES,
    GET_POLICIES_API_ERROR,
    GET_POLICIES_SUCCESS
    }
    from "./actionTypes.js";

const initialState = {
    loading: false,
    error: false,
    message: '',

    id: 0,
    loading: false,
    refresh: true,
    data: null,

    title: '',
    icon: '',
    content: '',
    show_menu: ''
}
    
const Policies = (state = initialState, action) => {

switch (action.type) {
        case GET_POLICIES:
            state = {
                ...state,
                loading: true,
                refresh: false,
            }
            break
        case GET_POLICIES_SUCCESS:
            state = {
                ...state,
                data: action.payload.data,
                refresh: false,
                loading: false
            }
            break
        case GET_POLICIES_API_ERROR:
            state = { ...state, error: action.payload, loading: false }
            break

        case GET_POLICIE:
            state = {
                ...state,
                loading: true,
                refresh: false,
            }
            break
        case GET_POLICIE_SUCCESS:
            state = {
                ...state,
                //data: action.payload.data,
                title: action.payload.data.title,
                icon: action.payload.data.icon,
                content: action.payload.data.content,
                show_menu: action.payload.data.show_menu,
                refresh: true,
                loading: false
            }
            break
        default:
            state = { ...state }
            break
    }

    return state
}

export default Policies;